<template>
  <div>
    <ic-dialog :show="showAlert">
      <div class="dialog-box">
<!--        <a @click.stop="$emit('close')" class="icon-btn close-btn mr-row close-button">-->
<!--          <i class='sr sr-close'></i>-->
<!--        </a>-->
        <div class="text-center">
          <img :src="this.type === 'warning' ? warning : this.type === 'info' ? info : this.type === 'success' ? success : null " alt="warning" style="min-width: 48px; min-height: 48px"/>
          <h4 class="mt-2">{{ title }}</h4>
        </div>
        <div class="contract-wrapper mt-2 mb-3 text-center">
          <div>
              <p v-if="preBody">{{ preBody }} </p>
            <br v-if="preBody">
              <p v-html="body"></p>
          </div>
        </div>
        <div class="text-center">
          <ic-button class="close-button mr-1" size="tn" @click="$emit('close')">
            Хаах
          </ic-button>
          <router-link :to="{ name: 'user-detail' }"
                       class="profile-item" v-show="hasContractButton">
            <ic-button class="contract-button ml-1" size="tn">
              Гэрээ
            </ic-button>
          </router-link>

        </div>
      </div>
    </ic-dialog>
  </div>
</template>
<style scoped lang="scss">
.dialog-box {
  position: relative;
}
.contract-wrapper {
  max-width: 80vh;
  //max-height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 12px;
  color: #939393;
  padding: 15px;
}
p {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: #939393;
}
h4{
  color: var(--blue-or-white-color);
}
.close-button{
  background: #939393 !important;
}
.contract-button{
  background: #0C293A !important;
}
button {
  min-width: 100px;
}

</style>
<script>
import warning from "../assets/images/warning.svg"
import checkGray from "../assets/images/check-gray.svg";
import checkGreen from "../assets/images/check-green.svg";
import router from "../router";

export default {
  methods: {
    router() {
      return router
    }
  },
  props: {
    showAlert: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'warning'
    },
    title: {
      type: String,
      default: 'Анхааруулга'
    },
    preBody: {
      type: String,
      required: false
    },
    body: {
      type: String,
      required: true
    },
    hasContractButton: {
      type: Boolean,
      default: true
    }

  },
  data() {
    return {
      warning: warning,
      info: checkGray,
      success: checkGreen,
    }
  },
}
</script>